module.exports = __webpack_public_path__ + "5fed890f83d0b80c4a46707fde8496ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Spotin_SymbolS_Ring_Blue_Big_RGB.png
// module id = 164
// module chunks = 0